const supports = {
	scheduling() {
		// FIXME: this condition causes tests not to represent the real browser behaviour
		return typeof window !== 'undefined' && typeof MessageChannel === 'function';
	},
};

export default supports;
